import { render } from "./UISandbox.vue?vue&type=template&id=76792c1b"
import script from "./UISandbox.vue?vue&type=script&lang=js"
export * from "./UISandbox.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__